<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div v-if="dataRow" class="row">
          <div v-if="dataRow.path" class="col-12 col-sm-6 text-center mb-4">
            <img :src="MEDIA_URL+dataRow.path" class="img-thumbnail" style="max-width: 250px;" alt="">
          </div>
          <div v-if="dataRow.pathEn" class="col-12 col-sm-6 text-center mb-4">
            <img :src="MEDIA_URL+dataRow.pathEn" class="img-thumbnail" style="max-width: 250px;" alt="">
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الصورة - عربي:</label>
            <input type="file" class="form-control" @change="setImage($event.target.files)">
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الصورة - إنجليزي:</label>
            <input type="file" class="form-control" @change="setImageEn($event.target.files)">
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">عند الضغط على الصورة:</label>
            <select v-model="actionType" class="form-control">
              <option :value="null">لا يوجد إجراء</option>
              <option value="link">يقوم بفتح صفحة ويب</option>
              <option value="page">يقوم بفتح صفحة داخل التطبيق</option>
            </select>
          </div>
          <div v-if="actionType == 'link'" class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">رابط صفحة الويب:</label>
            <input type="text" v-model="action" class="form-control">
          </div>
          <div v-if="actionType == 'page'" class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">اختر الصفحة:</label>
            <select v-model="action" class="form-control">
              <option :value="null">لم يحدد</option>
              <option value="manage_property_services">يقوم بفتح إدارة الاملاك</option>
              <option value="advertising">يقوم بفتح إضافة إعلان</option>
              <option value="maintenance">يقوم بفتح طلب صيانة</option>
              <option value="property_request">يقوم بفتح طلب عقار</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">حالة الإعلان:</label>
            <select v-model="isActive" class="form-control">
              <option :value="true">نشط</option>
              <option :value="false">غير نشط</option>
            </select>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast } from '@/helpers/tools';

export default {
  name: 'BannersForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      image: null,
      imageEn: null,
      actionType: null,
      action: null,
      isActive: true,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  methods: {
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;
      
      const formData = new FormData();
      formData.append('image', this.image);
      formData.append('imageEn', this.imageEn);
      formData.append('actionType', this.actionType);
      formData.append('action', this.action);
      formData.append('isActive', this.isActive);
      
      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/banners/update/${this.dataRow.id}`, formData);
      else
        api = this.$http.post('/api/admin/banners/create', formData);
      api.then(({data}) => {
        if(!this.dataRow){
          toast('تم إضافة الإعداد بنجاح', 'success');
          this.$router.replace('/banners').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
    setImage(files){
      this.image = files[0];
    },
    setImageEn(files){
      this.imageEn = files[0];
    },
  },
  created(){
    if(this.dataRow){
      this.actionType = this.dataRow.actionType;
      this.action = this.dataRow.action;
      this.isActive = this.dataRow.isActive;
    }
  }
}
</script>
